import { ICardCarousel } from '@models/ICardCarousel';
import Card from '@molecules/Card/Card';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import useProductPageContentStore from '@state/ProductPageStore';
import slugify from '@utils/helpers/slugify';
import { SwiperSlide } from 'swiper/react';

const CardCarousel = (props: ICardCarousel) => {
  const {
    title,
    list = [],
    meta,
  } = useProductPageContentStore().productPageContent?.cardCarousel || props;

  if (!list?.length) {
    return null;
  }

  return (
    <section
      className="component-padding overflow-hidden bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-59-Card-Carousel"
    >
      <NavigationCarousel
        id={`card-carousel-${meta?.contentLink ?? ''}`}
        items={list}
        title={title}
        titleClassName="h4"
      >
        {(itemsToDisplay) =>
          itemsToDisplay?.map((card, index) => (
            <SwiperSlide
              className="stretch-card h-auto"
              key={slugify(`${card.title}-${index}`)}
              data-testid="CT-59-Card-Carousel-Item"
            >
              <Card {...card} carouselTitle={title} />
            </SwiperSlide>
          ))
        }
      </NavigationCarousel>
    </section>
  );
};

export default CardCarousel;
